export function getPercentage(percentage: number | string | null) {
  return isNaN(Number(percentage)) ? 0 : Number(percentage);
}
